var FirstPage;
(function (FirstPage) {
    FirstPage["ONE"] = "1";
    FirstPage["ZERO"] = "0";
})(FirstPage || (FirstPage = {}));
export default FirstPage;
//# sourceMappingURL=first-page.js.map